var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileVersions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H6C5.17088 0 4.5 0.670875 4.5 1.5V22.5C4.5 23.3291 5.17088 24 6 24H18C18.8291 24 19.5 23.3291 19.5 22.5V1.5C19.5 0.670875 18.8291 0 18 0ZM18.75 22.5C18.75 22.914 18.414 23.25 18 23.25H6C5.586 23.25 5.25 22.914 5.25 22.5V19.5H18.75V22.5ZM18.75 18.75H5.25V3.75H18.75V18.75ZM18.75 3H5.25V1.5C5.25 1.086 5.586 0.75 6 0.75H18C18.414 0.75 18.75 1.086 18.75 1.5V3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.5C12.6217 22.5 13.125 21.9967 13.125 21.375C13.125 20.7533 12.6217 20.25 12 20.25C11.3783 20.25 10.875 20.7533 10.875 21.375C10.875 21.9967 11.3783 22.5 12 22.5ZM12 21C12.2074 21 12.375 21.1676 12.375 21.375C12.375 21.5824 12.2074 21.75 12 21.75C11.7926 21.75 11.625 21.5824 11.625 21.375C11.625 21.1676 11.7926 21 12 21Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 1.5H10.125C9.91763 1.5 9.75 1.66763 9.75 1.875C9.75 2.08237 9.91763 2.25 10.125 2.25H12.375C12.5824 2.25 12.75 2.08237 12.75 1.875C12.75 1.66763 12.5824 1.5 12.375 1.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 2.25C14.0821 2.25 14.25 2.08211 14.25 1.875C14.25 1.66789 14.0821 1.5 13.875 1.5C13.6679 1.5 13.5 1.66789 13.5 1.875C13.5 2.08211 13.6679 2.25 13.875 2.25Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileVersions);
export default __webpack_public_path__ + "static/media/mobileVersions.807b50cbe9a726e913b7806743d54ff1.svg";
export { ForwardRef as ReactComponent };